import React from "react";

const JellyNails = () => {
  return (
    <div className="blogWhat-content">
      <h5>9. Jelly Nails: Transparent & Playful</h5>
      <p>
        Jelly nails feature a see-through, translucent finish that gives a fun
        and playful vibe. This trend is particularly popular in bright neon
        shades, candy-colored pastels, and glass-like glossy effects. Ideal for
        shorter nails, jelly nails are fresh, youthful, and perfect for summer!
      </p>
    </div>
  );
};

export default JellyNails;
